import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';

import 'reset-css/reset.css';
import { initDash0 } from '~/common/helpers/dash0/initDash0';
import {
  loadRuntimeConfig,
  subscribeToConfigChanges
} from '~/common/helpers/environment';
import '~/common/helpers/i18n';
import App from '~/scenes/Others/scenes/App';
import './index.css';

// import { inspect } from '@xstate/inspect';

// // Habilite o DevTools para integração com o Visualizer
// if (process.env.NODE_ENV === 'development') {
//   inspect({
//     // Endereço do servidor remoto do Visualizer
//     iframe: false // Usa uma janela separada ao invés de um iframe
//   });
// }

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

subscribeToConfigChanges(() => {
  initDash0();
});

if (process.env.NODE_ENV === 'production') {
  loadRuntimeConfig()
    .then(() => {
      initDash0();
      root.render(<App />);
    })
    .catch(() => {
      root.render(<div>Failed to load config. Please refresh.</div>);
    });
} else {
  initDash0();
  root.render(<App />);
}
